import TakingOrderTable from "./component/TakingOrderTable";

function TakingOrderDelivery() {
  return (
    <>
      <TakingOrderTable status={3} nextStatus={4} hasAction/>
    </>
  );
}

export default TakingOrderDelivery;
